import { z } from 'zod'

/***************** 월 정산 지급 상태 *****************/
// 정산을 아직 확정하지 않은 달은 지급 대기(PENDING)다
export const SETTLEMENT_PAYMENT_STATUS = ['PAID', 'PENDING'] as const

/***************** 정산 계좌 심사 상태 *****************/
// 학원이 등록한 정산 계좌(신원 확인)의 심사 상태. 등록하지 않았으면 서버가 null 을 준다
export const SETTLEMENT_ACCOUNT_STATUS = ['REGISTERED', 'APPROVED', 'REJECTED'] as const

export const SettlementPaymentStatusSchema = z.enum(SETTLEMENT_PAYMENT_STATUS)
export type SettlementPaymentStatus = z.infer<typeof SettlementPaymentStatusSchema>

export const SettlementAccountStatusSchema = z.enum(SETTLEMENT_ACCOUNT_STATUS)
export type SettlementAccountStatus = z.infer<typeof SettlementAccountStatusSchema>

/***************** 월 정산 *****************/
// 학부모 결제로 받은 주문 묶음별 정산 예정·지급 금액
export const MonthlySettlementSchema = z.object({
  // yyyy-MM
  yearMonth: z.string(),
  status: SettlementPaymentStatusSchema,
  totalTargetAmount: z.number(),
  groupOrderList: z.array(
    z.object({
      groupOrderId: z.string(),
      // 상품 이름들을 서버가 하나의 문자열로 이어 보낸다
      productNames: z.string(),
      totalPaymentAmount: z.number(),
      expectedSettlementAmount: z.number(),
      paidSettlementAmount: z.number(),
    }),
  ),
})
export type MonthlySettlement = z.infer<typeof MonthlySettlementSchema>

/***************** 정산 계좌 *****************/
// 학원이 등록한 정산 계좌와 본인 확인 정보. 등록하지 않았으면 모든 필드가 null 이다.
// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 pod/model/dto/AcademySettlementWithIdentity.kt 로 확인.
export const SettlementAccountSchema = z.object({
  name: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  birthDate: z.iso.date().nullable(),
  bankName: z.string().nullable(),
  bankAccountNumber: z.string().nullable(),
  status: SettlementAccountStatusSchema.nullable(),
  /** 지급을 기다리는 정산 금액 */
  awaitingAmount: z.number().nullable(),
})
export type SettlementAccount = z.infer<typeof SettlementAccountSchema>
